var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Card from "@irati/ui/src/Layout/Card";
import { TopUpTypes } from "@irati/wallet/enums";
import getId from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import History from "@irati/utils/history";
import Amount from "@irati-web/fields/wallet/Amount";
import authentication from "@irati/auth";
import tracking from "@irati-tracking/wallet/tenantWallet";
import ErrorText from "@irati/ui/src/ErrorText";
import BANK_TRANSFER_MINIMUM from "@irati/wallet/constants/bankTransferMinimumAmount";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import { Strong } from "@irati/ui/src/Labels";
import ConfirmationPopup from "@irati-web/reward/src/components/ConfirmationPopup";
import mfaService from "@irati/auth/services/mfa";
import Loading from "@irati/ui/src/Loading";
import YouNeedToMfa from "@irati-web/mfa/components/Error/YouNeedToMfa";
import TermsAndConditions from "./TermsAndConditions";
import TopUpButtonWithMutation from "./TopUpButton";
import SelectPaymentMethod from "./SelectPaymentMethod";
import BankTransferConfirmationPopUp from "./BankTransferConfirmationPopUp";
import PONumber from "./PONumber";
var DEFAULT_AMOUNT = "100.00";
var TenantWalletTopUp = /** @class */ (function (_super) {
    __extends(TenantWalletTopUp, _super);
    function TenantWalletTopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            amount: DEFAULT_AMOUNT,
            paymentMethod: null,
            showInvoice: false,
            tenantWalletTopup: null,
            confirmedTandC: false,
            poNumber: null,
            showConfirmationPopup: false
        };
        _this.updateAmount = function (amount) {
            tracking.enterTopUpValue();
            _this.setState({ amount: amount, tenantWalletTopup: null });
        };
        _this.updateMethod = function (paymentMethod) {
            if (paymentMethod === TopUpTypes.BankTransfer) {
                tracking.selectBankTransfer();
            }
            else {
                tracking.selectPayWithCard();
            }
            _this.setState({ paymentMethod: paymentMethod });
        };
        _this.handleClose = function () {
            History.push({
                pathname: "/wallet/tenant"
            });
        };
        _this.handleInputComplete = function (_a) {
            var createTopUp = _a.createTopUp;
            tracking.completeTenantWalletTopUp();
            _this.setState({ showInvoice: true, tenantWalletTopup: createTopUp });
        };
        _this.isTopUpButtonDisabled = function () {
            var _a = _this.state, paymentMethod = _a.paymentMethod, confirmedTandC = _a.confirmedTandC;
            if (!paymentMethod) {
                return true;
            }
            if (!_this.isBankTransferAmountMet()) {
                return true;
            }
            return !confirmedTandC;
        };
        _this.isBankTransferAmountMet = function () {
            var _a = _this.state, paymentMethod = _a.paymentMethod, amount = _a.amount;
            if (paymentMethod === TopUpTypes.BankTransfer) {
                if (parseFloat(amount) < BANK_TRANSFER_MINIMUM) {
                    return false;
                }
            }
            return true;
        };
        _this.toggleTermsAndConditions = function () {
            _this.setState(function (prevState) {
                var confirmedTandC = !prevState.confirmedTandC;
                if (confirmedTandC) {
                    tracking.agreeTermsAndConditions();
                }
                return { confirmedTandC: confirmedTandC };
            });
        };
        _this.handleClick = function () {
            var _a = _this.state, paymentMethod = _a.paymentMethod, tenantWalletTopup = _a.tenantWalletTopup;
            if (paymentMethod === TopUpTypes.BankTransfer) {
                tracking.clickRequestInvoice();
            }
            else {
                tracking.clickTopUpCredit();
                History.push({
                    pathname: "/wallet/tenant/card-payment",
                    tenantWalletTopup: tenantWalletTopup
                });
            }
        };
        _this.handleMutate = function () {
            _this.handleHide();
            var _a = _this.state, tenantWalletTopup = _a.tenantWalletTopup, paymentMethod = _a.paymentMethod, mutate = _a.mutate;
            var skipMutation = !!(tenantWalletTopup && paymentMethod === TopUpTypes.PayWithCard);
            if (!skipMutation && mutate) {
                _this.setState({
                    mfaLoad: Promise.all([mfaService.hasFlag(), mutate()]).then(_this.handleClick)
                });
            }
            else {
                _this.setState({
                    mfaLoad: mfaService.hasFlag().then(_this.handleClick)
                });
            }
        };
        _this.handlePONumberUpdate = function (poNumber) {
            _this.setState({ poNumber: poNumber });
        };
        _this.handleHide = function () {
            _this.setState({ showConfirmationPopup: false });
        };
        _this.handleClickPreConfirmation = function (mutate) {
            _this.setState({ showConfirmationPopup: true, mutate: mutate });
        };
        _this.getPaymentTypeText = function () {
            var formatMessage = _this.props.formatMessage;
            return _this.state.paymentMethod === TopUpTypes.BankTransfer
                ? formatMessage({ id: "wallet.tenant.topUp.confirmationPopup.paymentType.bank" })
                : formatMessage({ id: "wallet.tenant.topUp.confirmationPopup.paymentType.card" });
        };
        _this.getConfirmationButtonText = function () {
            var formatMessage = _this.props.formatMessage;
            return _this.state.paymentMethod === TopUpTypes.BankTransfer
                ? formatMessage({ id: "wallet.tenant.topUp.confirmationPopup.button.bank" })
                : formatMessage({ id: "wallet.tenant.topUp.confirmationPopup.button.card" });
        };
        return _this;
    }
    TenantWalletTopUp.prototype.componentDidMount = function () {
        var tenantWalletTopup = this.props.tenantWalletTopup;
        if (tenantWalletTopup) {
            this.setState({
                tenantWalletTopup: tenantWalletTopup,
                amount: tenantWalletTopup.amount.amount.toFixed(2).toString(),
                paymentMethod: tenantWalletTopup.paymentType
            });
        }
    };
    TenantWalletTopUp.prototype.render = function () {
        var _this = this;
        var idNamespace = getId("top_up", this.props);
        var _a = this.state, amount = _a.amount, tenantWalletTopup = _a.tenantWalletTopup, paymentMethod = _a.paymentMethod, showInvoice = _a.showInvoice, confirmedTandC = _a.confirmedTandC, poNumber = _a.poNumber, showConfirmationPopup = _a.showConfirmationPopup, mfaLoad = _a.mfaLoad;
        var formatMessage = this.props.formatMessage;
        var isTopUpButtonDisabled = this.isTopUpButtonDisabled();
        var tenantName = authentication.userTenant().public_name;
        return (React.createElement(Loading, { load: mfaLoad, Error: function () { return (React.createElement(YouNeedToMfa, { onRetry: _this.handleMutate, title: formatMessage({ id: "wallet.tenant.topUp.mfa.error.title" }), body: formatMessage({ id: "wallet.tenant.topUp.mfa.error.body" }) })); } },
            React.createElement(Card, null,
                React.createElement(Amount, { amount: amount, id: getId("amount", idNamespace), updateAmount: this.updateAmount }),
                React.createElement(SelectPaymentMethod, { onChange: function () { return _this.updateMethod(TopUpTypes.BankTransfer); }, name: formatMessage({ id: "wallet.tenant.topUp.selectPaymentMethodName.bankTransfer" }), checked: paymentMethod === TopUpTypes.BankTransfer },
                    React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.selectContent.bankTransfer", values: { tenantName: tenantName } }),
                    paymentMethod === TopUpTypes.BankTransfer && React.createElement(PONumber, { value: poNumber, onChange: this.handlePONumberUpdate }),
                    React.createElement(TermsAndConditions, { handleChange: this.toggleTermsAndConditions, isActive: confirmedTandC, value: TopUpTypes.PayWithCard })),
                React.createElement(SelectPaymentMethod, { onChange: function () { return _this.updateMethod(TopUpTypes.PayWithCard); }, name: formatMessage({ id: "wallet.tenant.topUp.selectPaymentMethodName.card" }), checked: paymentMethod === TopUpTypes.PayWithCard },
                    React.createElement(TermsAndConditions, { handleChange: this.toggleTermsAndConditions, isActive: confirmedTandC, value: TopUpTypes.PayWithCard })),
                this.isBankTransferAmountMet() || (React.createElement(ErrorText, null,
                    React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.bankTransfer.errorText" }))),
                React.createElement(TopUpButtonWithMutation, { disabled: isTopUpButtonDisabled, buttonText: "platform.button.continue", paymentType: paymentMethod, amount: amount, poNumber: poNumber, type: paymentMethod === TopUpTypes.BankTransfer ? TopUpTypes.BankTransfer : TopUpTypes.PayWithCard, onComplete: this.handleInputComplete, onClick: this.handleClickPreConfirmation })),
            showInvoice && tenantWalletTopup && (React.createElement(BankTransferConfirmationPopUp, { details: tenantWalletTopup, showCompletionModal: showInvoice, handleClose: this.handleClose })),
            React.createElement(ConfirmationPopup, { title: "wallet.tenant.topUp.confirmationPopup.title", topText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.confirmationPopup.text1", values: {
                        type: this.getPaymentTypeText(),
                        amount: formatCurrency({ currencyCode: authentication.defaultUserCurrency(), value: amount, isCents: false })
                    } }), bottomText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.confirmationPopup.text2", values: {
                        boldText: (React.createElement(Strong, null,
                            React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.confirmationPopup.text2Bold" })))
                    } }), show: showConfirmationPopup, onHide: this.handleHide, onClick: this.handleMutate, backButtonText: "platform.button.goBack", continueButtonText: this.getConfirmationButtonText() })));
    };
    return TenantWalletTopUp;
}(PureComponent));
export default injectIntl(TenantWalletTopUp);
